import { Button, Icon, Menu, MenuButton, MenuDivider, MenuItem, MenuList } from '@chakra-ui/react';
import { useCustomThemeDraftDispatch, useCustomThemeDraftState } from '@olo-web/client-state';
import { useFeatureFlags } from '@olo-web/domain';
import { useThemeRoles } from '@olo-web/domain/firebaseAuth';
import { ECustomThemeViews } from '@olo-web/types/enums';
import { auth } from '@olo-web/utils/google/firebase';
import React, { useMemo } from 'react';
import { ChevronDown } from 'react-feather';
import { Label, label } from '../constants';

export const ThemeMenu = () => {
  const themeDispatch = useCustomThemeDraftDispatch();
  const { view } = useCustomThemeDraftState();
  const { isAdmin, isOwner } = useThemeRoles();
  const { data: flags } = useFeatureFlags();

  const handleLogout = () => {
    auth().signOut();
  };

  const handleSetView = (key: ECustomThemeViews) => {
    themeDispatch({
      type: 'SET_VIEW',
      payload: key,
    });
  };

  // TODO: We should convert this to use omit instead of `delete` as it would be simpler and easier to read
  const filteredLabels = useMemo(() => {
    const l: Label = { ...label };
    if (flags?.hideMerchantThemeFonts) {
      delete l[ECustomThemeViews.FONTS];
    }
    if (!flags?.enableQRCodePrinting?.on) {
      delete l[ECustomThemeViews.QR_CODES];
    }
    return l;
  }, [flags?.hideMerchantThemeFonts, flags?.enableQRCodePrinting?.on]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="lg"
        variant="ghost"
        colorScheme="blackAplha"
        rightIcon={<Icon as={ChevronDown} h={6} w={6} />}
        alignSelf="flex-start"
        textDecor="underline"
        px={view === ECustomThemeViews.QR_CODES ? 0 : view && (label?.[view] ? 2 : 0)}
        _hover={{
          color: 'primary.350',
        }}
      >
        {view ? label[view] ?? view : null}
      </MenuButton>
      <MenuList>
        {Object.keys(filteredLabels).map((key) => (
          <MenuItem key={key} onClick={() => handleSetView(key as ECustomThemeViews)}>
            {label[key]}
          </MenuItem>
        ))}
        <MenuDivider />
        {(isAdmin || isOwner) && (
          <>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.PIXELS_AND_KEYS)}>
              pixels and keys
            </MenuItem>
            {!flags.disableManageLocations ? (
              <MenuItem onClick={() => handleSetView(ECustomThemeViews.MANAGE_LOCATIONS)}>
                manage locations
              </MenuItem>
            ) : null}
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.MANAGE_ACCESS)}>
              manage access
            </MenuItem>
            <MenuItem onClick={() => handleSetView(ECustomThemeViews.SETTINGS)}>settings</MenuItem>
          </>
        )}
        {isAdmin && (
          <MenuItem onClick={() => handleSetView(ECustomThemeViews.ADMIN)}>admin</MenuItem>
        )}
        <MenuItem onClick={handleLogout} color="danger.300">
          logout
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
